import { render, staticRenderFns } from "./SimulationRevisions.vue?vue&type=template&id=2646c363&scoped=true"
import script from "./SimulationRevisions.vue?vue&type=script&lang=js"
export * from "./SimulationRevisions.vue?vue&type=script&lang=js"
import style0 from "./SimulationRevisions.vue?vue&type=style&index=0&id=2646c363&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2646c363",
  null
  
)

export default component.exports